import { Component, inject, signal } from "@angular/core"
import { Message } from "primeng/api"
import { AvailabilityService } from "src/app/services/availability.service"

@Component({
  selector: "ow-availability-check-result",
  templateUrl: "./availability-check-result.component.html",
  styleUrl: "./availability-check-result.component.css"
})
export class AvailabilityCheckResultComponent {
  public readonly availabilityService = inject(AvailabilityService)

  public messages: Message[] = []
  public showLinks = signal<boolean>(false)

  constructor() {
    this.availabilityService.availability$.subscribe((availability) => {
      if (availability) {
        if (availability.isAvailable) {
          if (availability.demandAggregation) {
            this.messages = [
              {
                severity: "warn",
                summary: 'Verfügbar für Vorvermarktung (siehe <a href="https://www.swsls.de/vorvermarktung.html" target="_blank">hier</a>)',
                detail: "An der angegebenen Adresse sind folgende Produkte verfügbar."
              }
            ]
          } else if (availability.nearNet) {
            this.messages = [
              {
                severity: "error",
                icon: "fa-solid fa-triangle-exclamation",
                summary: 'An der angegebenen Adresse sind folgende Produkte nach dem Bau eines kostenpflichtigen Hausanschlusses verfügbar. Weitere Informationen finden Sie <a href="https://www.swsls.de/glasfaserhausanschluss.html" target="_blank">hier</a>.'
              }
            ]
          } else {
            this.messages = [
              {
                severity: "success",
                summary: "Verfügbar",
                detail: "An der angegebenen Adresse sind folgende Produkte verfügbar."
              }
            ]
  
          }
          this.showLinks.set(false)
        } else {
          switch (availability.availabilityReason) {
            case "buildOutStatus":
              this.messages = [
                {
                  severity: "warn",
                  summary: "Noch nicht verfügbar",
                  detail: "Registrieren Sie sich jetzt als Interessent und fördern Sie somit den Ausbau in Ihrem Gebiet."
                }
              ]
              this.showLinks.set(true)
              break
            case "connectionStatus":
              this.messages = [
                {
                  severity: "warn",
                  summary: "An Ihrer Adresse ist ein Glasfaseranschluss bereits vorhanden",
                  detail: 'Es wurde ein erhöhter Bedarf an Glasfaseranschlüssen an Ihrer Adresse ermittelt. Bitte kontaktieren Sie unseren Kundenservice telefonisch <a href="tel:+4968319596335">06831 9596 -335</a> oder per Mail <a href="mailto:kundenservice@swsls.de">kundenservice@swsls.de</a>.'
                }
              ]
              this.showLinks.set(false)
              break
          }
        }
      } else {
        this.messages = []
        this.showLinks.set(false)
      }
    })
  }
}
